import React from "react";
import { Calendar, RefreshCcw, Clock3 } from "lucide-react";
import { formatSubscriptionDate } from "./subscriptionUtils";

const InfoCard = ({ icon, title, value, subtitle, danger, success }) => (
  <div className="info-card">
    <div className="info-icon">{icon}</div>
    <p className="info-title">{title}</p>
    <h3
      className={`info-value ${danger ? "danger" : ""} ${success ? "success" : ""}`}
    >
      {value}
    </h3>
    {subtitle && <p className="info-subtitle">{subtitle}</p>}
  </div>
);

const InfoCards = ({ subscription, isLoading, isError }) => {
  if (isLoading) {
    return <div className="info-grid">Loading...</div>;
  }

  if (isError) {
    return <div className="info-grid">Unable to load subscription info.</div>;
  }

  const plan = subscription?.plan;
  const trialAvailable =
    subscription?.trialAvailable ??
    plan?.trial?.isAvailable ??
    subscription?.trial?.isAvailable;
  const autoRenewal =
    subscription?.autoRenewal ?? subscription?.autoRenew ?? subscription?.isAutoRenew;

  return (
    <div className="info-grid">
      <InfoCard
        icon={<Calendar size={18} />}
        title="TRIAL AVAILABLE"
        value={
          trialAvailable === true
            ? "Yes"
            : trialAvailable === false
            ? "No"
            : "—"
        }
      />

      <InfoCard
        icon={<RefreshCcw size={18} />}
        title="AUTO RENEWAL"
        value={
          autoRenewal === true
            ? "Enabled"
            : autoRenewal === false
            ? "Disabled"
            : "—"
        }
        success={autoRenewal === true}
      />

      <InfoCard
        icon={<Calendar size={18} />}
        title="START DATE"
        value={
          formatSubscriptionDate(
            subscription?.startDate ?? subscription?.startedAt
          ) || "—"
        }
      />

      <InfoCard
        icon={<Clock3 size={18} />}
        title="EXPIRY DATE"
        value={
          formatSubscriptionDate(
            subscription?.expiryDate ??
              subscription?.expiresAt ??
              subscription?.endDate
          ) || "—"
        }
        danger
      />
    </div>
  );
};

export default InfoCards;
